<mbs-modal
  #modal
  [isCustomModal]="true"
  [title]="'shared:download-build.updateRecommended.title' | i18next">
  <ng-container modal-body>
    <p>{{ 'shared:download-build.updateRecommended.text' | i18next }}</p>
    <p class="mb-0">{{ question }}</p>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="respond(answer.Yes)">
      {{ 'shared:buttons.yes' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="respond(answer.No)">
      {{ 'shared:buttons.no' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
